import CourseEnrollment from '@/models/CourseEnrollment.js';
import BasePolicy from '@/policies/BasePolicy.js';

export default class CourseEnrollmentPolicy extends BasePolicy {
    viewAny(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'view a course enrollment') ||
            user.hasGroupPermissionWithinCourse(course, 'view a course enrollment')
        );
    }

    viewCourseEnrollmentPage(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'view the course enrollment page') ||
            user.hasGroupPermissionWithinCourse(course, 'view the course enrollment page')
        );
    }

    viewAnyOnUserPage(user, person) {
        return (
            user.id === person.id ||
            user.hasPermissionTo('view enrollments on profile page') ||
            user.hasGroupPermissionTo('view enrollments on profile page')
        );
    }

    view(user, courseEnrollment) {
        return (
            user.hasPermissionViaCourseTo(courseEnrollment.course, 'view a course enrollment') ||
            user.hasGroupPermissionWithinCourse(courseEnrollment.course, 'view a course enrollment')
        );
    }

    create(user, groupIds) {
        if (!groupIds) {
            return user.hasPermissionTo('create a course enrollment');
        }

        return user.hasGroupPermissionTo('create a course enrollment');
    }

    update(user, courseEnrollment) {
        return user.hasPermissionViaCourseTo(courseEnrollment.course, 'edit a course enrollment');
    }

    delete(user, course) {
        if (course instanceof CourseEnrollment) {
            course = course.course;
        }

        return user.hasPermissionViaCourseTo(course, 'delete a course enrollment');
    }

    deleteAny(user, course) {
        return user.hasPermissionViaCourseTo(course, 'delete a course enrollment');
    }
}
